import { render } from "./NotificationSettings.vue?vue&type=template&id=0458528d"
import script from "./NotificationSettings.vue?vue&type=script&lang=js"
export * from "./NotificationSettings.vue?vue&type=script&lang=js"
script.render = render

export default script